// --------------------------------------------------------
// COMPANY INTEGRATIONS FORM - CompanyIntegrationsForm
// --------------------------------------------------------

import { 
    Checkbox, 
    FormControlLabel, 
    Accordion, 
    AccordionSummary, 
    AccordionDetails, 
    Typography,
    Box,
    Tabs,
    Tab
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useFormikContext } from "formik";
import React, { useState } from "react";
import Colors from "../../constants/Colors";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import { Container, RowContainer } from "../../pages/company/companyRegister/CompanyRegister.styled";
import { H3, Text } from "../UI/generalLayout/Layout.styled";
import FormikTextField from "./FormikTextField";
import RightIcon from "./RightIcon";
import OrpenGeneralConfig from "../../pages/orpenConfig/components/OrpenGeneralConfig";
import OrpenTemplates from "../../pages/orpenConfig/components/OrpenTemplates";
import OrpenLogs from "../../pages/orpenConfig/components/OrpenLogs";
import ClinicFrameGeneralConfig from "../../pages/company/components/ClinicFrameGeneralConfig";
import ClinicFrameLogs from "../../pages/company/components/ClinicFrameLogs";

interface ICompanyIntegrationsForm {
  isEditState: boolean;
  isViewState: boolean;
  initialValues: any;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
  
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`orpen-tabpanel-${index}`}
        aria-labelledby={`orpen-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
      </div>
    );
}

const CompanyIntegrationsForm = ({
  isEditState,
  isViewState,
  initialValues,
}: ICompanyIntegrationsForm) => {
  const { values, errors, setFieldValue } = useFormikContext<any>();
  const { isMobile } = useResponsiveInfo();
  const [orpenTab, setOrpenTab] = useState(0);
  const [clinicFrameTab, setClinicFrameTab] = useState(0);

  return (
    <Box sx={{ mt: 2 }}>
        <Accordion defaultExpanded sx={{ mb: 2, borderRadius: '8px !important', '&:before': { display: 'none' }, boxShadow: '0px 2px 4px rgba(0,0,0,0.05)' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6" sx={{ color: Colors.SPM600, fontWeight: 'bold' }}>Clinic Frame</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {(isEditState || isViewState) ? (
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={clinicFrameTab} onChange={(e, v) => setClinicFrameTab(v)} aria-label="clinic frame tabs">
                                <Tab label="Geral" />
                                <Tab label="Logs" />
                            </Tabs>
                        </Box>
                        <TabPanel value={clinicFrameTab} index={0}>
                            <ClinicFrameGeneralConfig empresaId={initialValues.id} isViewState={isViewState} />
                        </TabPanel>
                        <TabPanel value={clinicFrameTab} index={1}>
                            <ClinicFrameLogs empresaId={initialValues.id} />
                        </TabPanel>
                    </Box>
                ) : (
                    <Box sx={{ p: 2 }}>
                        <Text color={Colors.GRAY400}>Salve a empresa para configurar a integração com o Clinic Frame.</Text>
                    </Box>
                )}
            </AccordionDetails>
        </Accordion>

        <Accordion sx={{ borderRadius: '8px !important', '&:before': { display: 'none' }, boxShadow: '0px 2px 4px rgba(0,0,0,0.05)' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6" sx={{ color: Colors.SPM600, fontWeight: 'bold' }}>WhatsApp (Orpen)</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {(isEditState || isViewState) ? (
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={orpenTab} onChange={(e, v) => setOrpenTab(v)} aria-label="orpen tabs">
                                <Tab label="Geral" />
                                <Tab label="Templates" />
                                <Tab label="Logs" />
                            </Tabs>
                        </Box>
                        <TabPanel value={orpenTab} index={0}>
                            <OrpenGeneralConfig empresaId={initialValues.id} isViewState={isViewState} />
                        </TabPanel>
                        <TabPanel value={orpenTab} index={1}>
                            <OrpenTemplates empresaId={initialValues.id} isViewState={isViewState} />
                        </TabPanel>
                        <TabPanel value={orpenTab} index={2}>
                            <OrpenLogs empresaId={initialValues.id} />
                        </TabPanel>
                    </Box>
                ) : (
                    <Box sx={{ p: 2 }}>
                        <Text color={Colors.GRAY400}>Salve a empresa para configurar a integração com a Orpen.</Text>
                    </Box>
                )}
            </AccordionDetails>
        </Accordion>
    </Box>
  );
};

export default CompanyIntegrationsForm;
